import $ from 'zepto';
import { onDocumentReady } from '../../main';
import { debounce } from '..';
import { normalizeCssSelector } from '../strings';

const $body = $(document.body);

const requiredField = ($context) => {
  const requiredInputArray = [];
  const $formWithValidation = $($context).find('.js-xvx-form-validation');

  if ($formWithValidation.length) {
    $formWithValidation.each((formIndex, form) => {
      const requiredFormRow = $(form).find('.xform-row.required input[type="text"], .xform-row.required input[type="password"]');
      const $buttonSubmit = $($context).find('button[type=submit]');
      // disabling button by default
      $buttonSubmit.attr('disabled', true);

      requiredFormRow.each((formRowIndex, requiredInput) => {
        const $requiredInput = $(requiredInput);
        requiredInputArray.push($requiredInput.get(0).id);

        const checkForValidInput = debounce(() => {
          const emptyInput = requiredInputArray.find((input) => !$(`#${normalizeCssSelector(input)}`).val().trim().length);

          if (!emptyInput) {
            return $buttonSubmit.removeAttr('disabled');
          }
          return $buttonSubmit.attr('disabled', true);
        }, 300);

        $requiredInput.off();
        $requiredInput.on('keydown', checkForValidInput);
      });
    });
  }
};

export default function initLegacyFieldValidation($context) {
  return requiredField($context);
}

onDocumentReady('LegacyFieldValidation', () => {
  initLegacyFieldValidation($body);
});
